/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@shared/apis/fetch-clients/radar-fetch-client";
import type { ListSubscriptionsQueryResponse, ListSubscriptionsQueryParams, ListSubscriptions400, ListSubscriptions403 } from "../../models/subscriptionAuditController/ListSubscriptions";
import type { Client, RequestConfig, ResponseErrorConfig } from "@shared/apis/fetch-clients/radar-fetch-client";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const listSubscriptionsQueryKey = (params?: ListSubscriptionsQueryParams) => [{ url: '/audit/event-subscriptions' }, ...(params ? [params] : [])] as const

export type ListSubscriptionsQueryKey = ReturnType<typeof listSubscriptionsQueryKey>

/**
 * @description Admin-only auditing view. Credentials are never returned: header values are replaced by the configured header names, and the target URL has its userinfo, query values, and fragment redacted. Includes the owner’s display name (`userName`).
 * @summary List event subscriptions across all users
 * {@link /audit/event-subscriptions}
 */
export async function listSubscriptions(params?: ListSubscriptionsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ListSubscriptionsQueryResponse, ResponseErrorConfig<ListSubscriptions400 | ListSubscriptions403>, unknown>({ method : "GET", url : `/audit/event-subscriptions`, params, ... requestConfig })
  return res.data
}

export function listSubscriptionsQueryOptions(params?: ListSubscriptionsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = listSubscriptionsQueryKey(params)
        return queryOptions<ListSubscriptionsQueryResponse, ResponseErrorConfig<ListSubscriptions400 | ListSubscriptions403>, ListSubscriptionsQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return listSubscriptions(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Admin-only auditing view. Credentials are never returned: header values are replaced by the configured header names, and the target URL has its userinfo, query values, and fragment redacted. Includes the owner’s display name (`userName`).
 * @summary List event subscriptions across all users
 * {@link /audit/event-subscriptions}
 */
export function useListSubscriptions<TData = ListSubscriptionsQueryResponse, TQueryData = ListSubscriptionsQueryResponse, TQueryKey extends QueryKey = ListSubscriptionsQueryKey>(params?: ListSubscriptionsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ListSubscriptionsQueryResponse, ResponseErrorConfig<ListSubscriptions400 | ListSubscriptions403>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? listSubscriptionsQueryKey(params)
         

         const query = useQuery({
          ...listSubscriptionsQueryOptions(params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ListSubscriptions400 | ListSubscriptions403>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}